// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WallPropsSections-module__propColumn--Cpinj {
    border-bottom: 1px solid var(--color-secondary-light);
    padding-bottom: 12px;
}

.WallPropsSections-module__highlightIndicator--M4veY {
    --size: 7px;
    display: inline-block;
    width: var(--size);
    height: var(--size);
    border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/dom/Demo/RoomSetup/WallPropsSections.module.css"],"names":[],"mappings":"AAAA;IACI,qDAAqD;IACrD,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB","sourcesContent":[".propColumn {\n    border-bottom: 1px solid var(--color-secondary-light);\n    padding-bottom: 12px;\n}\n\n.highlightIndicator {\n    --size: 7px;\n    display: inline-block;\n    width: var(--size);\n    height: var(--size);\n    border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"propColumn": `WallPropsSections-module__propColumn--Cpinj`,
	"highlightIndicator": `WallPropsSections-module__highlightIndicator--M4veY`
};
export default ___CSS_LOADER_EXPORT___;
